import React from 'react';
import { StyledContainer, StyledBody } from './EmailItem.styles';
import {
    StyledAvatar,
    StyledFullName,
    StyledTimeText,
    StyledSubject,
} from '../EmailTab.styles';
import { Box, Icon, useTheme, Stack } from '../../../../base';
import {
    IServerJobApplicationEmail,
    formatMessageTime,
} from '../../../../common';

interface Props {
    emailData: IServerJobApplicationEmail;
    onClick?: () => void;
}

const EmailItem = (props: Props) => {
    const { emailData, onClick } = props;
    const { user, subject, body, files, created_at } = emailData;
    const theme = useTheme();

    const fullName = `${user.first_name} ${user.last_name}`;
    const userImage = user.image;

    const formattedTime = formatMessageTime(created_at);

    return (
        <StyledContainer container onClick={onClick} sx={{ cursor: 'pointer' }}>
            <StyledAvatar name={fullName} src={userImage} />
            <Box sx={{ marginInlineStart: 1, lineHeight: 1.2, flex: 1 }}>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        paddingBottom: 0.5,
                    }}
                >
                    <StyledFullName component="span">{fullName}</StyledFullName>
                    <StyledTimeText variant="caption">
                        {formattedTime}
                    </StyledTimeText>
                    {files && files.length > 0 && (
                        <Icon
                            name="AttachFileIcon"
                            style={{
                                color: theme.palette.secondary.main,
                                width: 16,
                                height: 16,
                                transform: 'rotate(45deg)',
                            }}
                        />
                    )}
                </Box>
                <Stack spacing={0.5}>
                    <StyledSubject variant="body1">{subject}</StyledSubject>
                    <StyledBody variant="body2">{body}</StyledBody>
                </Stack>
            </Box>
        </StyledContainer>
    );
};

export default EmailItem;
